import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "address-book_3oRy1",
  "use": "address-book_3oRy1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"address-book_3oRy1\">\n    <rect x=\"5\" y=\"4\" width=\"14\" height=\"16\" stroke=\"currentColor\" fill=\"none\" />\n    <circle cx=\"12\" cy=\"10\" r=\"3\" stroke=\"currentColor\" fill=\"none\" />\n    <path d=\"M8,18c1-2,7-2,8,0\" stroke=\"currentColor\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol